import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchMembershipPool } from 'store/actions/membership-pools/fetchMembershipPools';
import MembershipPoolCreateForm from '../create/MembershipPoolCreateForm';
import { updateMembershipPool } from 'store/actions/membership-pools/updateMembershipPools';

class MembershipPoolEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                id: id,
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/membership-pools`));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('menu.sidebar.membership_pools'),
                link: '/membership-pools',
            },
            {
                label: data.name,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.memberships.actions.edit', {
                        title: data.name,
                    }) } />

                    <Actions>
                        <ListButton url={ `/membership-pools` } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <MembershipPoolCreateForm
                            initialValues={ data }
                            form='membership_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

MembershipPoolEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            dispatch(updateMembershipPool(payload));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchMembershipPool,
        resource: 'membership-pools',
    })
);

export default enhance(MembershipPoolEditContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-pools/edit/MembershipPoolEditContainer.js